import {
  INITIAL_COMMON_STATE,
  MasonryEngineNodeStateFromNode,
} from '../masonry-engine-state-controller';
import { type MasonryEngineNode } from '../types/masonry-engine-node.types';

/**
 * Given a `MasonryEngineNode`, builds the state object for this node from its properties
 * and backend states.
 */
export const composeInitialNodeState = <Node extends MasonryEngineNode>(
  node: Node,
): MasonryEngineNodeStateFromNode<Node> => ({
  ...node.properties,
  ...INITIAL_COMMON_STATE,
  ...(node.states || {}),
});
